import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';

interface TooltipLabelProps {
  label: string;
  tooltip: string;
  className?: string;
}

export function TooltipLabel({ label, tooltip, className }: TooltipLabelProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={`cursor-help border-b border-dotted border-gray-400 text-gray-700 ${className ?? ''}`}
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs text-xs">{tooltip}</TooltipContent>
    </Tooltip>
  );
}
